// Junta todos los ficheros de este idioma: cada `<área>.json` es un espacio de
// claves con su nombre (`marco.json` → `t("marco.…")`). Un fichero nuevo entra
// solo, sin tocar este.
const ficheros = require.context(".", false, /\.json$/);

export default Object.fromEntries(
  ficheros.keys().map((ruta) => [ruta.replace(/^\.\/|\.json$/g, ""), ficheros(ruta)]),
);
